import Image from "next/image";
import Heading from "~/componentsDS/Typography/Heading";

type MessagingCardProps = {
    imageUrl?: string;
    alt?: string;
};

const defaultImageUrl = "https://res.cloudinary.com/dirscuuhp/image/upload/c_crop,w_874,h_1187,x_105,y_140/v1777993271/chat_1_2.webp";

const MessagingCard = ({imageUrl= defaultImageUrl, alt = "Inner Balance app showing unlimited support messaging"}: MessagingCardProps) => {
    return (
        <div className="relative h-[450px] overflow-hidden rounded-[16px] bg-[rgb(233,237,247)] md:h-[554px] w-full px-12 pt-3 md:pt-12">
            <Heading
                as="h3"
                font="featureDisplay"
                weight="400"
                className="
                    relative z-[1] pt-5 text-center
                    text-[28px] !leading-[1.1] text-primary500
                "
            >
                Unlimited <br />
                secured messaging
            </Heading>

            <Image
                src={imageUrl}
                alt={alt}
                width={320}
                height={420}
                sizes="(max-width: 768px) 100vw, 560px"
                className="
                    pointer-events-none absolute bottom-0 left-1/2
                    w-[82%] max-w-[260px] -translate-x-1/2
                    object-contain
                    md:w-[76%] md:max-w-[320px]
                "
            />
        </div>
    );
};

export default MessagingCard;
